import React, { CSSProperties } from 'react';
import { ContentListItem } from '../../../_lib/components/ContentList';

export type CategoriesListItemProps = {
  children: React.ReactNode;
  style?: CSSProperties;
};

/**
 * CategoriesListItem with modifiert to be mapped to each category.
 */
export function CategoriesListItem({ children, style }: CategoriesListItemProps) {
  return (
    <ContentListItem modifier={['border-left', 'padding-10-top-bottom']} style={style}>
      {children}
    </ContentListItem>
  );
}
